import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import ReactDom from 'react-dom';

import { SearchPart, TablePart } from '../../Parts';

class ListTemplate extends Component {
  constructor() {
    super();

    this.state = {
      listData: [],
      isLoading: false,
      searchParams: null
    };

    this.beforeSearch = this.beforeSearch.bind(this);
    this.success = this.success.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }
  onSearch(params) {
    this.setState({
      searchParams: params
    });

    this.table.search(params);
  }
  beforeSearch() {
    this.setState({
      isLoading: true,
      listData: []
    });
  }
  success(data) {
    this.setState({
      isLoading: false,
      listData: data
    });
  }

  render() {
    const { listFormat, operations, searches, url, operationsRule } = this.props;
    const { isLoading, listData, searchParams } = this.state;
    return (
      <div>
        <SearchPart
          title="查询列表"
          conditions={searches}
          onSearch={this.onSearch}
          beforeSearch={this.beforeSearch}
        />
        <TablePart
          title="查询结果"
          items={listData}
          minWidth={1200}
          isLoading={isLoading}
          itemFormat={listFormat}
          operations={operations}
          operationsRule={operationsRule}
          ref={(item) => {
            this.table = item;
          }}
          beforeSearch={this.beforeSearch}
          success={this.success}
          searchParams={searchParams}
          url={url}
        />
      </div>
    );
  }
}

ListTemplate.propTypes = {
  searches: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  listFormat: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  operations: PropTypes.arrayOf(PropTypes.shape()),
  operationsRule: PropTypes.shape(),
  url: PropTypes.string.isRequired
};

ListTemplate.defaultProps = {
  operations: [],
  operationsRule: {}
};
const render = function (props) {
  ReactDom.render(
    <ListTemplate {...props} />,
    document.getElementById('root')
  );
};


export default function renderList(props) {
  render(props);
}



// WEBPACK FOOTER //
// ./src/Templates/ListTemplate/index.js